export const S3Config = {
    bucketName: "smsbucket22",
    region: "af-south-1",
    accessKeyId: "AKIAZJUHHXPJHHGWDGX7",
    secretAccessKey: "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"
}
